import * as React from 'react'

import {
  i18n,
  useSiteConfig,
  useSiteDefinition,
} from '@thg-commerce/enterprise-core'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { getPrice } from '@thg-commerce/enterprise-product-options/src/utils/price'
import { Price, ProductImage } from '@thg-commerce/gravity-elements'

import { useReviewsPage } from '../../../context'

import { Container, ImageContainer, Title } from './styles'

interface ProductBlockProps {
  url: string
  productName: string
  customerReviewsTitle: string
}

const title = (
  displayMasterSKUTitle,
  selectedVariant,
  product,
  customerReviewsTitle,
) => `
  ${
    (displayMasterSKUTitle
      ? selectedVariant?.masterSkuTitle
      : selectedVariant?.title) || product?.title
  } ${customerReviewsTitle}
`

export const ProductBlock = ({
  url,
  customerReviewsTitle,
}: ProductBlockProps) => {
  const { defaultLocale, defaultCurrency } = useSiteDefinition()
  const { product, selectedVariant } = useReviewsPage()
  const { displayMasterSKUTitle } = useSiteConfig()
  const theme = useTheme()

  const i18nText = {
    rrpLabel: i18n('general.rrp.text'),
    saveLabel: i18n('general.save.text'),
    fromLabel: i18n('reviews.paginatedproductreviews.productblock.from.text'),
  }

  return (
    <Container
      as="a"
      href={url}
      {...{
        condensed: true,
        directions: ['column'],
      }}
    >
      <Title
        data-testid="reviews-heading-level-1"
        textStyle={theme.pageTheme?.productSummary?.title?.textStyle}
        margin={theme.pageTheme?.productSummary?.title?.margin}
      >
        {title(
          displayMasterSKUTitle,
          selectedVariant,
          product,
          customerReviewsTitle,
        )}
      </Title>
      {selectedVariant && (
        <Price
          priceTheme={{
            price: theme.pageTheme.productSummary.price.price,
            rrp: theme.pageTheme.productSummary.price.rrp,
            savings: theme.pageTheme.productSummary.price.savings,
            priceWithRRP: theme.pageTheme.productSummary.price.priceWithRRP,
          }}
          priceDirection={theme.pageTheme.productSummary.price.direction}
          displayRRPText={theme.pageTheme.productSummary.price.displayRRPText}
          pricing={getPrice(selectedVariant, defaultLocale, defaultCurrency)}
          i18nText={{
            rrpLabel: i18nText.rrpLabel,
            saveLabel: i18nText.saveLabel,
            fromLabel: i18nText.fromLabel,
          }}
        />
      )}
      <ImageContainer>
        <ProductImage
          width={[300]}
          urls={{
            largeProduct:
              (selectedVariant?.images || []).length > 0
                ? selectedVariant?.images[0].largeProduct
                : (product?.images && product?.images[0].largeProduct) || '',
          }}
          alt={selectedVariant?.title || product?.title || ''}
        />
      </ImageContainer>
    </Container>
  )
}
